import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

interface DialogState {
  isOpen: boolean;
  title?: string;
  content?: string;
  data?: any;
}

@Injectable({
  providedIn: 'root'
})
export class AddAccountsDialogService {
  private dialogState = new BehaviorSubject<DialogState>({ isOpen: false });
  dialogState$ = this.dialogState.asObservable();

  private confirmSubject = new BehaviorSubject<any>(null);
  confirm$ = this.confirmSubject.asObservable();

  open(title: string, content: string, data?: any) {
    this.dialogState.next({ isOpen: true, title, content, data });
  }

  close() {
    this.dialogState.next({ isOpen: false });
  }

  confirm(data?: any) {
    this.confirmSubject.next(data);
    this.close();
  }
}